import { Directive, Input, TemplateRef, ViewContainerRef, ElementRef } from '@angular/core'

@Directive({ selector: '[highlight]' })
export class HighlightDirective {
  constructor(private el: ElementRef) {}

  @Input('highlight') set highlight(searchValue: string) {
    const ele = this.el.nativeElement
    const name = ele.getAttribute('title')
    const key = searchValue.trim()

    if (!!key && !!name && name.includes(searchValue)) {
      ele.innerHTML = name.replaceAll(key, `<span class="font-highlight">${key}</span>`)
    } else if (!!name) {
      ele.innerHTML = name
    }
  }
}
